import styled, { css } from "styled-components";

export const StatusButton = styled.button`
  ${(props) =>
    props.isActive &&
    css`
      background-color: #f3b1b1;
    `};
`;
